import GRSElevenOne from '../../../Wagons/GRS wagons/GRSElevenOne/GRSElevenOne';
import GRTOne from '../../../Wagons/GRT wagons/GRTOne/GRTOne';
import GRSThirteenNine from '../../../Wagons/GRS wagons/GRSThirteenNine/GRSThirteenNine';
import GRTTwo from '../../../Wagons/GRT wagons/GRTTwo/GRTTwo';
import GRTFour from '../../../Wagons/GRT wagons/GRTFour/GRTFour';
import GRTTwoFour from '../../../Wagons/GRT wagons/GRTTwoFour/GRTTwoFour';
import GRTThree from '../../../Wagons/GRT wagons/GRTThree/GRTThree';
import ARMLux from '../../../Wagons/ARM wagons/ARMLux/ARMlux';
import GRTOneFour from '../../../Wagons/GRT wagons/GRTOneFour/GRTOneFour';
import VMKTwoThree from '../../../Wagons/VMK wagons/VMKTwoThree/VMKTwoThree';
import MapImageEighteen from '../../../Wagons/mapImageWagons/mapImageEighteen/MapImageEighteen';
import MapImageHundred from '../../../Wagons/mapImageWagons/mapImageHundred/MapImageHundred';
import MapImageNineteen from '../../../Wagons/mapImageWagons/mapImageNineteen/MapImageNineteen';
import MapImageSixty from '../../../Wagons/mapImageWagons/mapImageSixty/MapImageSixty';
import MapImageSixtyOne from '../../../Wagons/mapImageWagons/mapImageSixtyOne/MapImageSixtyOne';
import MapImageSixtyTwo from '../../../Wagons/mapImageWagons/mapImageSixtyTwo/MapImageSixtyTwo';
import MapImageSixtyThree from '../../../Wagons/mapImageWagons/mapImageSixtyThree/MapImageSixtyThree';
import MapImageSixtyFour from '../../../Wagons/mapImageWagons/mapImageSixtyFour/MapImageSixtyFour';
import MapImageOne from '../../../Wagons/mapImageWagons/mapImageOne/MapImageOne';
import MapImageThree from '../../../Wagons/mapImageWagons/mapImageThree/MapImageThree';
import MapImageEleven from '../../../Wagons/mapImageWagons/mapImageEleven/MapImageEleven';
import MapImageSixtySix from '../../../Wagons/mapImageWagons/mapImageSixtySix/MapImageSixtySix';
import MapImageTwelve from '../../../Wagons/mapImageWagons/mapImageTwelve/MapImageTwelve';
import MapImageSixtyFive from '../../../Wagons/mapImageWagons/mapImageSixtyFive/MapImageSixtyFive';
import MapImageThirteen from '../../../Wagons/mapImageWagons/mapImageThirteen/MapImageThirteen';
import MapImageSeventeen from '../../../Wagons/mapImageWagons/mapImageSeventeen/MapImageSeventeen';
import MapImageFifteen from '../../../Wagons/mapImageWagons/mapImageFifteen/MapImageFifteen';
import MapImageFourteen from '../../../Wagons/mapImageWagons/mapImageFourteen/MapImageFourteen';
import MapImageTwo from '../../../Wagons/mapImageWagons/mapImageTwo/MapImageTwo';

const wagonComponents = {
  0: GRSThirteenNine,
  1: MapImageOne,
  2: MapImageTwo,
  3: MapImageThree,
  4: GRSElevenOne,
  5: GRTOne,
  6: GRTTwo,
  7: GRTOneFour,
  8: GRTTwoFour,
  9: GRTFour,
  10: VMKTwoThree,
  11: MapImageEleven,
  12: MapImageTwelve,
  13: MapImageThirteen,
  14: MapImageFourteen,
  15: MapImageFifteen,
  16: GRTThree,
  17: MapImageSeventeen,
  18: MapImageEighteen,
  19: MapImageNineteen,
  60: MapImageSixty,
  61: MapImageSixtyOne,
  62: MapImageSixtyTwo,
  63: MapImageSixtyThree,
  64: MapImageSixtyFour,
  65: MapImageSixtyFive,
  66: MapImageSixtySix,
  67: ARMLux,
  100: MapImageHundred,
};

function ReturnWagon({
  data,
  index,
  chosenSeats,
  setChosenSeats,
  reserveSeat,
  unReserveSeat,
}) {
  const carriageMapId = Number(data?.carriages[index]?.carriage_map_id);
  const Wagon = wagonComponents[carriageMapId];

  if (!Wagon) return null;

  return (
    <Wagon
      carriageInfo={data?.carriages[index]}
      wagonNumber={data?.carriages[index]?.order_number}
      chosenSeats={chosenSeats}
      setChosenSeats={setChosenSeats}
      reserveSeat={reserveSeat}
      unReserveSeat={unReserveSeat}
    />
  );
}

export default ReturnWagon;
